var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload-cloud-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M6.66406 13.3333L9.9974 10M9.9974 10L13.3307 13.3333M9.9974 10V17.5M16.6641 13.9524C17.682 13.1117 18.3307 11.8399 18.3307 10.4167C18.3307 7.88536 16.2787 5.83333 13.7474 5.83333C13.5653 5.83333 13.3949 5.73833 13.3025 5.58145C12.2158 3.73736 10.2094 2.5 7.91406 2.5C4.46228 2.5 1.66406 5.29822 1.66406 8.75C1.66406 10.4718 2.36027 12.0309 3.48652 13.1613",
    stroke: "#4C5965",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.e82b45ad9dd5eef33ca1dbf33fb33eb3.svg";
export { ForwardRef as ReactComponent };